<h2 mat-dialog-title>Unsaved Changes</h2>
<mat-dialog-content class="mat-typography">
	<p>You have unsaved changes on this page that will be lost. How would you like to proceed?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button [mat-dialog-close]="false">Cancel</button>
	<button mat-raised-button color="primary" mat-dialog-close="NoSave" cdkFocusInitial>Continue w/o Saving</button>
	<button mat-raised-button color="primary" mat-dialog-close="Save" cdkFocusInitial>Save & Continue</button>
</mat-dialog-actions>
